import { Box } from '@mui/joy';

import { usePermissionsContext } from '../context/permissionsContext';

import { Navbar } from './navbar/Navbar';

interface PropTypes {
  children: React.ReactNode;
}
const Layout = ({ children }: PropTypes) => {
  const { isVersionMismatch } = usePermissionsContext();
  return (
    <>
      <Navbar />
      <Box
        id='layout'
        sx={{
          position: 'fixed',
          top: isVersionMismatch ? '90px' : '62px',
          mx: 'auto',
          width: 1,
          height: isVersionMismatch ? 'calc(100vh - 90px)' : 'calc(100vh - 62px)',
          overflowY: 'scroll',
        }}
      >
        {children}
      </Box>
    </>
  );
};

export { Layout };
